export { default } from "./CurriculumHeader";
